import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { FormSubmitted } from "../../../@types/formSubmitted";
import { Template } from "../../../@types/template";

import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";

export const findUserTemplateList = createAsyncThunk(
    "userTemplate/findUserTemplateList",
    async (user: string, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.get(`${api.baseURL}formsubmitted`, {
                params: {
                    populate: "form",
                    select: "id,form",
                    where: { user: user }
                }
            });
            const result = data.map((item: FormSubmitted) => item.form);
            return result as Template[];
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
